export default __webpack_public_path__ + "static/media/profile.c0bf88c7.png";